/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi, createStore, createEffect, sample } from 'effector';

import { updateInvestbox } from '../api';
import { AggregateInvestbox } from '../types/aggregateInvestbox';
import { StandartResponse } from '../types/standartResponse';

type TAggregateInvestboxes$State = {
  total: number;
  investboxes: AggregateInvestbox[];
};

const initial: TAggregateInvestboxes$State = {
  total: 0,
  investboxes: [],
};

export const aggregateInvestboxes = createStore<TAggregateInvestboxes$State>(initial);

const { update } = createApi(aggregateInvestboxes, {
  // @ts-ignore
  update: (state, { result }: { result: StandartResponse<AggregateInvestbox> }) => {
    if (result && result.success && result.result?.id) {
      const id = result?.result?.id;
      // @ts-ignore
      const update = state.investboxes.filter((s) => s.id === id);
      if (update) {
        // #todo
      }
    }

    return state;
  },
});

export const aggregateInvestboxesApi = {
  update: createEffect<Partial<AggregateInvestbox>, StandartResponse<AggregateInvestbox>, any>().use(updateInvestbox),
};

sample({
  clock: aggregateInvestboxesApi.update.done,
  target: update,
});
